import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialInputModule } from '../../modules/@material-input/material-input.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DataTableModule } from '../../modules/@datatable/datatables.module';
import { SharedModule } from '../../shared/shared.module';
import {TariffMapTableComponent} from './tariff-map-table.component';
import {AbleproDirectivesModule} from '../../_front/core/ablepro-directives.module';
import {TariffMapLogComponent} from './tariff-map-log/tariff-map-log.component';
import {TariffMapLogResolve} from './tariff-map-log/tariff-map-log.resolve';
import {PaginatorModule} from '../../shared/housing-modules/modules';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DataTableModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialInputModule,
    SharedModule,
    AbleproDirectivesModule,
    PaginatorModule,
  ],
  declarations: [
    TariffMapTableComponent,
    TariffMapLogComponent,
  ],
  exports: [
    TariffMapTableComponent,
    TariffMapLogComponent,
  ],
  providers: [
    TariffMapLogResolve,
  ]
})
export class TariffMapModule { }
